export default class ConversationTemplateVariableModel {
  id!: number;

  nome!: string;

  posicao!: number;
}
